import { useAppStateContext } from '../../../hooks/useAppState';


// As the name of the component suggests, this is the Multi Parameter Index tab
export default function MPITab({ children }) {
  const { bmpState, getDisplayLabel, getBmpTypeDisplayName, ANALYSIS_TYPE_LABELS } = useAppStateContext();
  return (
    <>
      <h2 className="text-lg font-semibold mb-4">Multi-Parameter Index</h2>
      
      
      {/* Instructions */}
        <div className="mb-6">
            <p className="text-sm text-gray-700 mb-4">
                This tab will use data from Hydrology and Water Quality Performance Index (if selected an analyte or analytes) to calculate a multi-parameter index based on user-defined priorities for different analytes.
            </p>
            
            <p className="text-sm text-gray-700 mb-2">
              Default parameters and input threshold concentrations are:
            </p>
            <ul className="list-disc ml-6 text-sm text-gray-700 mb-4">
              <li>Specified on Water Quality Index tab</li>
              <li>NA for Hydrology parameters</li>
            </ul>
            
            <p className="text-sm text-gray-700 mb-2">
              Priority rankings are (descriptions listed on Overview tab):
            </p>
            <ul className="list-disc ml-6 text-sm text-gray-700">
              <li>High (default)</li>
              <li>Medium</li>
              <li>Low</li>
              <li>Not Interested</li>
            </ul>
        </div>

      {/* BMP Selection Display */}
      <div className="mb-4 p-4 bg-gray-50 rounded-lg">
        <h3 className="text-md font-semibold mb-2">Current BMP Selection:</h3>
        <div className="text-sm text-gray-600">
          <p><strong>Analysis Type:</strong> {getDisplayLabel(bmpState.analysistype, ANALYSIS_TYPE_LABELS) || 'Not selected'}</p>
          {bmpState.analysistype === "individual" && (
            <>
              <p><strong>Site Name:</strong> {bmpState.sitename || 'Not selected'}</p>
              <p><strong>BMP Name:</strong> {bmpState.bmpname || 'Not selected'}</p>
            </>
          )}
          {bmpState.analysistype === "bmptype" && (
            <p><strong>BMP Type:</strong> {getBmpTypeDisplayName(bmpState.bmptype) || 'Not selected'}</p>
          )}
          {bmpState.analysistype === "treatmenttrain" && (
            <p><strong>Site Name:</strong> {bmpState.sitename || 'Not selected'}</p>
          )}
        </div>
      </div>

      {/* Children content (e.g., MPISelectionTable, MashupGoButton, OverallPerformancePanel) */}
      {children && <div>{children}</div>}
    </>
  );
} 